(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-bundles"] && !Shopify.designMode) return;
  try {
    
(() => {
function init(root=document){
root.querySelectorAll('.ch-bundle-slider:not(.is-ready)').forEach(section=>{
const cards=[...section.querySelectorAll('.ch-offer')],range=section.querySelector('input[type="range"]'),controls=section.querySelector('.ch-bundle-controls'),buttons=[...section.querySelectorAll('[data-bundle-index]')];
if(!cards.length)return;
function show(index){
index=Math.max(0,Math.min(cards.length-1,index));
cards.forEach((card,i)=>card.hidden=i!==index);
range.value=index;
range.setAttribute('aria-valuetext',cards[index].innerText.replace(/\s+/g,' ').trim());
range.style.setProperty('--bundle-progress',(cards.length>1?index/(cards.length-1)*100:0)+'%');
buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
}
section.classList.add('is-ready');controls.hidden=false;range.disabled=cards.length===1;
show(Math.min(2,cards.length-1));
range.addEventListener('input',()=>show(Number(range.value)));
buttons.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
section.addEventListener('shopify:block:select',event=>{const index=cards.findIndex(card=>card===event.target||card.contains(event.target));if(index>=0)show(index)});
});
}
init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.ch-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ch-mobile-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.ch-mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function revealSections() {
    if (observer) observer.disconnect();
    document.querySelectorAll('.ch-reveal-pending').forEach(el => el.classList.remove('ch-reveal-pending'));
    if (preference.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('ch-reveal-pending');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.ch-heading-row,.ch-product-tile,.ch-benefit,.ch-custom,.ch-film,.ch-newsletter,.ch-photo-card').forEach((el, index) => {
      el.classList.add('ch-reveal');
      el.style.setProperty('--reveal-delay', `${(index % 3) * 70}ms`);
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('ch-reveal-pending');
        observer.observe(el);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealSections, { once: true });
  else revealSections();
  document.addEventListener('shopify:section:load', revealSections);
  preference.addEventListener('change', revealSections);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 function setup(root = document) {
  root.querySelectorAll('.ch-reviews-pop .ch-review-grid').forEach(track => {
   if (track.dataset.autoReviews) return;
   track.dataset.autoReviews = 'true';
   track.closest('section').querySelectorAll('[data-review-dir]').forEach(button=>button.addEventListener('click',()=>{const card=track.querySelector('.ch-review');track.scrollBy({left:Number(button.dataset.reviewDir)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:reduced.matches?'auto':'smooth'});}));
   let pausedUntil = 0;
   let hovering = false;
   const pause = () => { pausedUntil = Date.now() + 12000; };
   track.addEventListener('pointerdown', pause, {passive:true});
   track.addEventListener('touchstart', pause, {passive:true});
   track.addEventListener('wheel', pause, {passive:true});
   track.addEventListener('keydown', pause);
   track.addEventListener('mouseenter', () => { hovering = true; });
   track.addEventListener('mouseleave', () => { hovering = false; });
   const timer = setInterval(() => {
    if (!track.isConnected) { clearInterval(timer); return; }
    if (matchMedia('(max-width:700px)').matches || reduced.matches || window.Shopify?.designMode || document.hidden || hovering || Date.now() < pausedUntil || track.contains(document.activeElement)) return;
    const box = track.getBoundingClientRect();
    if (box.top >= innerHeight || box.bottom <= 0 || track.scrollWidth <= track.clientWidth + 5) return;
    const cards = [...track.querySelectorAll('.ch-review')];
    const nearest = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft) < best.distance ? {index:i,distance:Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft)} : best, {index:0,distance:Infinity}).index;
    const next = cards[(nearest + 1) % cards.length];
    track.scrollTo({left:next.offsetLeft - track.offsetLeft,behavior:'smooth'});
   }, 4500);
  });
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), {once:true}); else setup();
 document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
